import { useCases } from "./homeData";

export function UseCasesSection() {
  return (
    <section className="py-20 md:py-24 bg-navy-band border-y border-navy-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-12">
          <p className="overline mb-3">Use cases</p>
          <h2 className="h-display text-3xl md:text-4xl">Made for UK leasehold work.</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {useCases.map((u) => (
            <div key={u.name} className="card-soft p-7" data-testid={`usecase-${u.name}`}>
              <p className="font-display text-lg text-navy-900">{u.name}</p>
              <p className="mt-2 text-sm text-navy-600 leading-relaxed">{u.desc}</p>
            </div>
          ))}
        </div>
        <p className="mt-10 text-sm text-navy-500">
          Also useful for: enfranchisement valuations, RTM disputes, ground rent challenges, freehold purchases, and managing block-of-flats cases.
        </p>
      </div>
    </section>
  );
}
